import React from "react";
import s from "./DashboardMockup.module.scss";

const GROSS_BARS = [42, 64, 50, 74, 56, 86, 62, 92, 70, 96, 66, 90];
const PHONE_BARS = [44, 70, 54, 84, 62, 92, 74];

const NAV_ITEMS = [
  "Dashboard",
  "Onboarding",
  "Product Listing",
  "Orders",
  "Customers",
];

const TOP_STATS = [
  { label: "Users", value: "8.8k" },
  { label: "Sessions", value: "10.2k" },
  { label: "Bounce rate", value: "46.2%" },
  { label: "Avg. time", value: "4m 24s" },
];

const PHONE_STATS = [
  { label: "Users", value: "8.8k" },
  { label: "Sessions", value: "10.2k" },
  { label: "Bounce", value: "46.2%" },
  { label: "Avg. time", value: "4m" },
];

const MINI_CARDS = [
  { label: "Today's revenue", value: "$1,280", color: "#22c55e" },
  { label: "Today's orders", value: "14", color: "#f97316" },
  { label: "Avg. order value", value: "$91.42", color: "#8b5cf6" },
];

export const DashboardMockup = () => (
  <div className={s.stage}>
    {/* ---------------- Desktop window ---------------- */}
    <div className={s.window}>
      <div className={s.topbar}>
        <span className={s.brand}>
          <span className={s.brandMark} />
          <span className={s.brandText}>Socommerz</span>
        </span>
        <span className={s.spacer} />
        <span className={s.tdot} />
        <span className={s.tdot} />
        <span className={s.avatar} />
      </div>

      <div className={s.body}>
        <aside className={s.sidebar}>
          {NAV_ITEMS.map((item, i) => (
            <span
              className={`${s.nav} ${i === 0 ? s.navActive : ""}`}
              key={item}
            >
              {item}
            </span>
          ))}
        </aside>

        <main className={s.main}>
          <div className={s.heading}>
            <span className={s.hTitle}>Dashboard</span>
            <span className={s.hSub}>Your insights, now at your fingertips</span>
          </div>

          <div className={s.statRow}>
            {TOP_STATS.map((stat) => (
              <div className={s.statTile} key={stat.label}>
                <span className={s.statLabel}>{stat.label}</span>
                <span className={s.statValue}>{stat.value}</span>
              </div>
            ))}
          </div>

          <div className={s.charts}>
            <div className={s.chartCard}>
              <div className={s.chartHead}>
                <span className={s.chartTitle}>Gross Sales</span>
                <span className={s.chartPill}>12 months</span>
              </div>
              <div className={s.bars}>
                {GROSS_BARS.map((h, i) => (
                  <span
                    className={s.bar}
                    key={i}
                    style={{ height: `${h}%` } as React.CSSProperties}
                  />
                ))}
              </div>
            </div>

            <div className={s.chartCard}>
              <div className={s.chartHead}>
                <span className={s.chartTitle}>Total Orders</span>
                <span className={s.chartPill}>12 months</span>
              </div>
              <svg
                className={s.lineChart}
                viewBox="0 0 120 56"
                preserveAspectRatio="none"
              >
                <defs>
                  <linearGradient id="lineFill" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#a855f7" stopOpacity="0.25" />
                    <stop offset="100%" stopColor="#a855f7" stopOpacity="0" />
                  </linearGradient>
                </defs>
                <path
                  className={s.lineArea}
                  d="M0 44 C18 40 26 30 40 32 S70 22 82 26 S108 10 120 14 L120 56 L0 56 Z"
                  fill="url(#lineFill)"
                />
                <path
                  className={s.linePath}
                  d="M0 44 C18 40 26 30 40 32 S70 22 82 26 S108 10 120 14"
                />
              </svg>
            </div>
          </div>

          <div className={s.miniRow}>
            {MINI_CARDS.map((card) => (
              <div className={s.miniCard} key={card.label}>
                <span className={s.miniLabel}>{card.label}</span>
                <span className={s.miniValue}>{card.value}</span>
                <svg
                  className={s.spark}
                  viewBox="0 0 60 18"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M0 14 C10 12 14 6 22 8 S40 4 48 9 S58 3 60 5"
                    fill="none"
                    stroke={card.color}
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>

    {/* ---------------- Phone ---------------- */}
    <div className={s.phone}>
      <span className={s.phoneNotch} />
      <div className={s.phoneScreen}>
        <div className={s.phHead}>
          <span className={s.phTitle}>Dashboard</span>
          <span className={s.phSub}>Your insights</span>
        </div>

        <div className={s.phTabs}>
          <span className={`${s.phTab} ${s.phTabActive}`}>Overview</span>
          <span className={s.phTab}>Balance</span>
          <span className={s.phTab}>Receipts</span>
        </div>

        <div className={s.phStats}>
          {PHONE_STATS.map((stat) => (
            <div className={s.phStat} key={stat.label}>
              <span className={s.phStatLabel}>{stat.label}</span>
              <span className={s.phStatValue}>{stat.value}</span>
            </div>
          ))}
        </div>

        <div className={s.phChart}>
          <span className={s.phChartTitle}>Gross Sales</span>
          <div className={s.phBars}>
            {PHONE_BARS.map((h, i) => (
              <span
                className={s.phBar}
                key={i}
                style={{ height: `${h}%` } as React.CSSProperties}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);
